import {DBBase} from './DBBase';

export class DBDropdowns extends DBBase {
    /**
     * @param {Object} component
     */
    constructor(component) {
        super(
            component,
            '/dropdowns'
        );
    }

    getCountries() {
        this.request('/countries');
    }

    getStates() {
        this.request('/states');
    }

    getCities() {
        this.request('/cities');
    }
}
